import { useQuery } from "@tanstack/react-query";

import { ApiResponse } from "types/api";

import { Filter } from "./types";

// @todo TAP-767: Delete the mocked response.
const RESPONSE_MOCK: Filter[] = [
  {
    id: "modifiedAfter",
    description: "",
    displayName: "modifiedAfter",
    hasSuggestions: false,
    param: "YYYY-MM-DDTHH:MM:SS",
    values: [],
  },
  {
    id: "modifiedBefore",
    description: "",
    displayName: "modifiedBefore",
    hasSuggestions: false,
    param: "YYYY-MM-DDTHH:MM:SS",
    values: [],
  },
];

// @todo TAP-767: Delete the query handler and reimplement it in tivoAppsApi.
export const usePublicationHistoryFilters = () => {
  return useQuery<ApiResponse<Filter[]>>({
    queryKey: ["publicationHistoryFilters"],
    queryFn: async () => ({
      results: RESPONSE_MOCK,
    }),
  });
};
